module.exports = __webpack_public_path__ + "static/media/partner_with_us_illustration.515ca2b3.png";